import ProfileContainer from "./ProfileContainer"; 
import ProfileStore from "./ProfileStore";

export default ProfileStore(ProfileContainer);